import { useSafeAreaInsets } from 'react-native-safe-area-context';

import theme from '@themes/theme';

import { Box } from '../Restyle';

interface HeaderWrapperProps {
  simple?: boolean;
  children: React.ReactNode;
  topWrap?: boolean;
  borderBottomWidth?: number;
}

export const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
  children,
  simple,
  topWrap = true,
  borderBottomWidth = 1,
}) => {
  const insets = useSafeAreaInsets();
  const getPaddingTop = () => {
    if (!topWrap) {
      return theme.spacing.m;
    }
    if (simple) {
      return 'auto';
    }
    return insets.top;
  };

  return (
    <Box
      paddingHorizontal='m'
      paddingBottom='m'
      borderBottomColor='grey02'
      borderBottomWidth={borderBottomWidth}
      flexDirection='row'
      alignItems='center'
      style={{ paddingTop: getPaddingTop() }}
      backgroundColor='white'>
      {children}
    </Box>
  );
};
